import { render, staticRenderFns } from "./CrewCard.vue?vue&type=template&id=0e006438&lang=pug&"
import script from "./CrewCard.vue?vue&type=script&lang=js&"
export * from "./CrewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports